/* STORMROCK — bloc 3 infos dans le cadre de l'image (fiche produit, mobile).
   Données : window.SR_PDP, posé par snippets/sr-pdp-infos.liquid.
   Rien n'est rendu sur la page d'accueil ni sur les pages collection :
   ce fichier n'est chargé que par le gabarit produit. */
(function () {
  var D = window.SR_PDP;
  if (!D) return;

  var NS = 'http://www.w3.org/2000/svg';

  function svg(inner, cls, size) {
    return '<svg class="' + cls + '" viewBox="0 0 24 24" width="' + size + '" height="' + size +
      '" xmlns="' + NS + '">' + inner + '</svg>';
  }

  /* ---------- drapeaux ---------- */
  var CLIP = '<defs><clipPath id="srfc"><rect x="3" y="3" width="18" height="18" rx="3.5"/></clipPath></defs>';
  function flag(inner) {
    return svg(CLIP + '<g clip-path="url(#srfc)">' + inner + '</g>' +
      '<rect x="3" y="3" width="18" height="18" rx="3.5" fill="none" stroke="rgba(0,0,0,.14)" stroke-width="1"/>',
      'sr-flag', 16);
  }
  function vbands(a, b, c) {
    return '<rect x="3" y="3" width="6" height="18" fill="' + a + '"/>' +
           '<rect x="9" y="3" width="6" height="18" fill="' + b + '"/>' +
           '<rect x="15" y="3" width="6" height="18" fill="' + c + '"/>';
  }
  function hbands(a, b, c) {
    return '<rect x="3" y="3" width="18" height="6" fill="' + a + '"/>' +
           '<rect x="3" y="9" width="18" height="6" fill="' + b + '"/>' +
           '<rect x="3" y="15" width="18" height="6" fill="' + c + '"/>';
  }
  /* Douze etoiles en cercle : a 16 px, des disques se lisent mieux que des
     etoiles a cinq branches, qui deviennent des taches. */
  function euStars() {
    var out = '', i, ang, x, y;
    for (i = 0; i < 12; i++) {
      ang = (i / 12) * 2 * Math.PI;
      x = 12 + 5.4 * Math.sin(ang);
      y = 12 - 5.4 * Math.cos(ang);
      out += '<circle cx="' + x.toFixed(2) + '" cy="' + y.toFixed(2) + '" r="1.05" fill="#FFCC00"/>';
    }
    return out;
  }

  var FLAGS = {
    france: vbands('#0055A4', '#FFFFFF', '#EF4135'),
    belgique: vbands('#2D2926', '#FAE042', '#ED2939'),
    italie: vbands('#008C45', '#F4F5F0', '#CD212A'),
    irlande: vbands('#169B62', '#FFFFFF', '#FF883E'),
    suisse: '<rect x="3" y="3" width="18" height="18" fill="#D52B1E"/>' +
            '<path d="M11 7.6h2v3.4h3.4v2H13v3.4h-2V13H7.6v-2H11Z" fill="#fff"/>',
    autriche: hbands('#ED2939', '#FFFFFF', '#ED2939'),
    allemagne: hbands('#000000', '#DD0000', '#FFCE00'),
    pays_bas: hbands('#AE1C28', '#FFFFFF', '#21468B'),
    espagne: '<rect x="3" y="3" width="18" height="18" fill="#AA151B"/>' +
             '<rect x="3" y="8" width="18" height="8" fill="#F1BF00"/>',
    portugal: '<rect x="3" y="3" width="18" height="18" fill="#FF0000"/>' +
              '<rect x="3" y="3" width="7.5" height="18" fill="#006600"/>' +
              '<circle cx="10.5" cy="12" r="2.6" fill="#FFD100" stroke="#fff" stroke-width=".7"/>',
    pologne: '<rect x="3" y="3" width="18" height="9" fill="#FFFFFF"/>' +
             '<rect x="3" y="12" width="18" height="9" fill="#DC143C"/>',
    republique_tcheque: '<rect x="3" y="3" width="18" height="9" fill="#FFFFFF"/>' +
             '<rect x="3" y="12" width="18" height="9" fill="#D7141A"/>' +
             '<path d="M3 3l9 9-9 9Z" fill="#11457E"/>',
    etats_unis: '<rect x="3" y="3" width="18" height="18" fill="#FFFFFF"/>' +
             '<rect x="3" y="3" width="18" height="2.6" fill="#B31942"/>' +
             '<rect x="3" y="8.2" width="18" height="2.6" fill="#B31942"/>' +
             '<rect x="3" y="13.4" width="18" height="2.6" fill="#B31942"/>' +
             '<rect x="3" y="18.4" width="18" height="2.6" fill="#B31942"/>' +
             '<rect x="3" y="3" width="9" height="8.2" fill="#0A3161"/>',
    maroc: '<rect x="3" y="3" width="18" height="18" fill="#C1272D"/>' +
             '<path d="M12 8.2l1.35 4.15h4.36l-3.53 2.56 1.35 4.15L12 16.5l-3.53 2.56 1.35-4.15-3.53-2.56h4.36Z" fill="none" stroke="#006233" stroke-width="1.1"/>',
    jamaique: '<rect x="3" y="3" width="18" height="18" fill="#009B3A"/>' +
             '<path d="M3 3h6l-6 9Zm18 0h-6l6 9Zm0 18h-6l6-9ZM3 21h6l-6-9Z" fill="#000"/>' +
             '<path d="M3 3l18 18M21 3L3 21" stroke="#FED100" stroke-width="3.2"/>',
    inde: '<rect x="3" y="3" width="18" height="6" fill="#FF9933"/>' +
             '<rect x="3" y="9" width="18" height="6" fill="#FFFFFF"/>' +
             '<rect x="3" y="15" width="18" height="6" fill="#138808"/>' +
             '<circle cx="12" cy="12" r="2.2" fill="none" stroke="#000080" stroke-width="1"/>',
    thailande: '<rect x="3" y="3" width="18" height="18" fill="#FFFFFF"/>' +
             '<rect x="3" y="3" width="18" height="3.6" fill="#A51931"/>' +
             '<rect x="3" y="17.4" width="18" height="3.6" fill="#A51931"/>' +
             '<rect x="3" y="9.6" width="18" height="4.8" fill="#2D2A4A"/>',
    union_europeenne: '<rect x="3" y="3" width="18" height="18" fill="#003399"/>' + euStars(),
    grece: '<rect x="3" y="3" width="18" height="18" fill="#FFFFFF"/>' +
             '<rect x="3" y="3" width="18" height="2.6" fill="#0D5EAF"/>' +
             '<rect x="3" y="8.2" width="18" height="2.6" fill="#0D5EAF"/>' +
             '<rect x="3" y="13.4" width="18" height="2.6" fill="#0D5EAF"/>' +
             '<rect x="3" y="18.4" width="18" height="2.6" fill="#0D5EAF"/>' +
             '<rect x="3" y="3" width="8" height="7.8" fill="#0D5EAF"/>' +
             '<path d="M6.4 3v7.8M3 6.6h7.8" stroke="#fff" stroke-width="1.6"/>'
  };
  var FLAG_ALIAS = {
    'france': 'france', 'french': 'france',
    'suisse': 'suisse', 'switzerland': 'suisse', 'swiss': 'suisse',
    'italie': 'italie', 'italy': 'italie', 'italienne': 'italie',
    'espagne': 'espagne', 'spain': 'espagne',
    'portugal': 'portugal',
    'pays-bas': 'pays_bas', 'pays bas': 'pays_bas', 'hollande': 'pays_bas', 'netherlands': 'pays_bas',
    'belgique': 'belgique', 'allemagne': 'allemagne', 'autriche': 'autriche',
    'pologne': 'pologne', 'irlande': 'irlande', 'grece': 'grece',
    'republique tcheque': 'republique_tcheque', 'tchequie': 'republique_tcheque',
    'republique tchequie': 'republique_tcheque', 'czech': 'republique_tcheque',
    'californie': 'etats_unis', 'california': 'etats_unis', 'usa': 'etats_unis',
    'etats-unis': 'etats_unis', 'etats unis': 'etats_unis', 'amerique': 'etats_unis',
    'american genetics': 'etats_unis', 'us': 'etats_unis',
    'maroc': 'maroc', 'morocco': 'maroc',
    'jamaique': 'jamaique', 'jamaica': 'jamaique', 'jamaicaine': 'jamaique',
    'inde': 'inde', 'india': 'inde',
    'thailande': 'thailande', 'thailand': 'thailande',
    'union europeenne': 'union_europeenne', 'ue': 'union_europeenne',
    'europe': 'union_europeenne', 'european union': 'union_europeenne'
  };
  /* Libellés trop longs pour une cellule : forme courte affichée. */
  var SHORT = {
    'republique tcheque': 'Tchéquie',
    'republique tchequie': 'Tchéquie',
    'tchequie': 'Tchéquie',
    'etats-unis': 'États-Unis',
    'etats unis': 'États-Unis',
    'pays-bas': 'Pays-Bas',
    'anti anxiete': 'Anti-anxiété',
    'anti-anxiete': 'Anti-anxiété',
    'union europeenne': 'U.E.'
  };

  function slug(s) {
    var t = String(s || '').toLowerCase().trim();
    if (t.normalize) t = t.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return t.replace(/\s+/g, ' ');
  }

  /* ---------- feuille de cannabis + icônes d'effet ---------- */
  var LEAF = 'M12.0 21.3Q9.7 18.9 5.9 20.0Q8.9 22.5 12.0 21.3ZM12.0 21.3Q10.4 16.9 5.0 16.2Q7.4 21.1 12.0 21.3Z' +
    'M12.0 21.3Q12.5 15.4 6.7 11.7Q6.7 18.6 12.0 21.3ZM12.0 21.3Q16.0 15.4 12.0 8.1Q8.0 15.4 12.0 21.3Z' +
    'M12.0 21.3Q17.3 18.6 17.3 11.7Q11.5 15.4 12.0 21.3ZM12.0 21.3Q16.6 21.1 19.0 16.2Q13.6 16.9 12.0 21.3Z' +
    'M12.0 21.3Q15.1 22.5 18.1 20.0Q14.3 18.9 12.0 21.3Z';
  function leafIcon() { return svg('<path class="sr-ico-fill" d="' + LEAF + '"/>', 'sr-leaf', 16); }

  function stroked(d, size) {
    return svg('<g class="sr-ico-stroke" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
      d + '</g>', 'sr-eff', size || 15);
  }
  var EFF = {
    wave: stroked('<path d="M3 10.5c1.9-2.4 3.8-2.4 5.7 0s3.8 2.4 5.7 0 3.8-2.4 5.6 0"/>' +
                  '<path d="M3 16c1.9-2.4 3.8-2.4 5.7 0s3.8 2.4 5.7 0 3.8-2.4 5.6 0"/>'),
    shield: stroked('<path d="M12 3.4l6.6 2.6v5.2c0 4-2.8 7.2-6.6 8.4-3.8-1.2-6.6-4.4-6.6-8.4V6Z"/>'),
    spark: stroked('<path d="M12 3.6l1.9 5.3 5.3 1.9-5.3 1.9L12 18l-1.9-5.3L4.8 10.8l5.3-1.9Z"/>'),
    bolt: stroked('<path d="M13.4 3.2 6.8 13.1h4.6L10.6 20.8l6.6-9.9h-4.6Z"/>'),
    moon: stroked('<path d="M20.2 14.6A8.2 8.2 0 0 1 9.4 3.8a8.2 8.2 0 1 0 10.8 10.8Z"/>')
  };
  var EFFET_MAP = {
    'relaxant': 'wave', 'relax': 'wave', 'relaxante': 'wave', 'detente': 'wave',
    'anti anxiete': 'shield', 'anti-anxiete': 'shield', 'apaisant': 'shield',
    'soulagement': 'shield',
    'euphorie': 'spark', 'creativite': 'spark', 'happy': 'spark', 'joyeux': 'spark',
    'focus': 'bolt', 'clarte': 'bolt', 'energie': 'bolt', 'energique': 'bolt', 'energy': 'bolt',
    'reverie': 'moon', 'sommeil': 'moon', 'sleep': 'moon', 'nuit': 'moon'
  };

  /* ---------- valeurs ---------- */
  function pct(v) {
    if (v === null || v === undefined || v === '') return '';
    var n = parseFloat(String(v).replace(',', '.'));
    if (isNaN(n)) return String(v);
    var s = (Math.round(n * 10) / 10).toString().replace('.', ',');
    return s + ' %';
  }

  function cell(label, value, icon) {
    var d = document.createElement('div');
    d.className = 'sr-pdp-infos__cell';
    var n = String(value).length;
    var size = n > 12 ? ' sr-pdp-infos__val--xlong' : (n > 8 ? ' sr-pdp-infos__val--long' : '');
    d.innerHTML = '<div class="sr-pdp-infos__label">' + label + '</div>' +
      '<div class="sr-pdp-infos__val' + size + '">' +
      (icon || '') + '<span>' + value + '</span></div>';
    return d;
  }

  /* Le libelle du taux suit la molecule de la fiche : DELTA-10, CBD, THCP...
     Sans metachamp cbd_ou_molecule, on garde CBD, valeur historique. */
  function tauxLabel() {
    var m = String(D.molecule || '').trim();
    return 'Taux de ' + (m || 'CBD');
  }

  function build() {
    var cells = [];
    if (D.origine) {
      var ks = slug(D.origine);
      var key = FLAG_ALIAS[ks];
      cells.push(cell('Provenance', SHORT[ks] || D.origine, key ? flag(FLAGS[key]) : ''));
    }
    var taux = pct(D.taux);
    if (taux) cells.push(cell(tauxLabel(), taux, leafIcon()));
    if (D.effet) {
      var es = slug(D.effet);
      var e = EFFET_MAP[es] || 'wave';
      cells.push(cell('Effet', SHORT[es] || D.effet, EFF[e]));
    }
    if (!cells.length) return null;
    var wrap = document.createElement('div');
    wrap.className = 'sr-pdp-infos';
    cells.forEach(function (c, i) {
      if (i) {
        var s = document.createElement('div');
        s.className = 'sr-pdp-infos__sep';
        wrap.appendChild(s);
      }
      wrap.appendChild(c);
    });
    return wrap;
  }

  function hidePill() {
    var media = document.querySelector('.product-information__media');
    if (!media) return;
    var mol = String(D.molecule || '').trim().toUpperCase();
    var nodes = media.querySelectorAll('.metafield-display');
    for (var i = 0; i < nodes.length; i++) {
      var t = (nodes[i].textContent || '').trim();
      if (t.length >= 20) continue;
      var doublon = /CBD/i.test(t) || (mol && t.toUpperCase().indexOf(mol) !== -1);
      if (doublon) nodes[i].setAttribute('data-sr-pdp-hidden', '');
    }
  }

  /* Le bloc vit DANS le cadre de l'image, au-dessus du titre.
     20/09/2026 : tentative de le deplacer sous le titre annulee. Deux degats :
     il ne s'affichait plus du tout (le titre n'est pas un <h1> dans ce theme),
     et surtout un noeud etranger insere dans la colonne d'information cassait
     le re-rendu des variantes, cette colonne etant morphee a chaque changement
     de format. La zone media, elle, n'est pas morphee : on y reste. */
  function mount() {
    var box = document.querySelector('.product-information__media slideshow-container');
    if (!box) return false;
    if (box.querySelector('.sr-pdp-infos')) return true;
    var node = build();
    if (!node) return true;
    box.appendChild(node);
    hidePill();
    return true;
  }

  function start() {
    if (mount()) {
      var media = document.querySelector('.product-information__media');
      if (!media || !window.MutationObserver) return;
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(mount, 120);
      }).observe(media, { childList: true, subtree: true });
      return;
    }
    var tries = 0;
    var iv = setInterval(function () {
      if (mount() || ++tries > 40) clearInterval(iv);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
